// API Configuration
// This file manages the API base URL for network access

// Get the hostname from window.location
const getApiBaseUrl = () => {
  // Check if we're in development mode
  if (process.env.NODE_ENV === 'development') {
    // Try to get API URL from environment variable
    const envApiUrl = process.env.REACT_APP_API_URL;
    if (envApiUrl) {
      return envApiUrl;
    }
    
    // Get current hostname (works for both localhost and network IP)
    const hostname = window.location.hostname;
    
    // If accessing via localhost, use localhost for API
    // If accessing via IP address, use same IP for API
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:5000';
    } else {
      // Use the same hostname (IP address) for API
      return `http://${hostname}:5000`;
    }
  }
  
  // Production mode - use environment variable or default
  const productionUrl = process.env.REACT_APP_API_URL || 'https://prachar.affluentix.com';
  return productionUrl;
};

// Export the API base URL
export const API_BASE_URL = getApiBaseUrl();

// Helper function to get full API URL
export const getApiUrl = (endpoint) => {
  // Remove leading slash if present
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_BASE_URL}/${cleanEndpoint}`;
};

// Log the API URL in development for debugging
if (process.env.NODE_ENV === 'development') {
  console.log('🔗 API Base URL:', API_BASE_URL);
  console.log('💡 To access from other devices on same network:');
  console.log(`   Frontend: http://${window.location.hostname}:3000`);
  console.log(`   Backend: ${API_BASE_URL}`);
}

